import { cn } from '@/lib/cn';

/*
 * Símbolo: cabide branco em quadrado verde-oliva arredondado (a marca da landing).
 * Fonte em public/logo-mark.svg. Cor fixa da marca, igual em tema claro e escuro.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" aria-hidden className={cn('size-8', className)}>
      <rect width="64" height="64" rx="15" fill="#5c6b2e" />
      <g fill="none" stroke="#fff" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M32 27.5V25c0-2.2 1.6-3.4 3.4-3.9 2.7-.7 4.6-2.7 4.6-5.1a8 8 0 1 0-15.6-2.6" />
        <path d="M32 27.5 13.3 41.4c-2.4 1.8-1.1 5.6 1.9 5.6h33.6c3 0 4.3-3.8 1.9-5.6L32 27.5Z" />
      </g>
    </svg>
  );
}

/** Marca em uso fora da sidebar (telas de autenticação). */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5 font-display text-lg font-extrabold tracking-tight', className)}>
      <LogoMark />
      <span>
        Brechô<span className="text-primary">Flow</span>
      </span>
    </span>
  );
}
